import { h, Fragment } from "preact";

import classname from "../../../../../foundation/utils/classname";
import { getRoleIconName, getUserRoleString } from "../../../../../foundation/utils/legacy";
import ResponsiveImage from "../../../../ResponsiveImage";
import { PopoverAlignment, PopoverPosition } from "../../../Popover";
import TeyzeTooltip, { TeyzeTooltipProps } from "../../TeyzeTooltip";

import styles from "./PermissionTeyzeTooltip.module.css";

type UserRole = "queen" | "rook" | "knight" | "pawn" | string;

interface Props extends TeyzeTooltipProps {
    role: UserRole;
    action: string;
    minimumRole?: UserRole;
}

const SUPPORT_LINK = "https://support.zeplin.io/pricing-and-plans/organization/assigning-roles-to-organization-members";

function PermissionTooltip({
    class: cssClass,
    role,
    action,
    minimumRole = "rook",
    position = PopoverPosition.Bottom,
    alignment = PopoverAlignment.End,
    children,
    ...teyzeTooltipProps
}: Props) {
    function getRoleIcon() {
        const iconName = getRoleIconName(role);

        return (
            <ResponsiveImage asset={`img/${iconName}.png`} alt={iconName}/>
        );
    }

    function generatePermissionTooltipMessage() {
        return (
            <>
                <p>
                    Your workspace role is {getUserRoleString(role)} {getRoleIcon()}, only
                </p>
                <p>
                    {getUserRoleString(minimumRole)}s or higher can {action}.
                </p>
                <p>
                    Contact your Admin to update your role!
                </p>
            </>
        );
    }

    return (
        <TeyzeTooltip
            {...teyzeTooltipProps}
            class={classname(styles.permissionTeyzeTooltip, cssClass)}
            position={position}
            alignment={alignment}
            text={generatePermissionTooltipMessage()}
            link={{
                label: "Learn more",
                to: SUPPORT_LINK,
                isExternal: true
            }}
            withHover>
            {children}
        </TeyzeTooltip>
    );
}

export default PermissionTooltip;
export {
    Props as PermissionTooltipProps
};
